import React from 'react';
import {generateAIVideosText} from '../generateAIVideosText';
import YesNoOption from '../../../../uiToolkit/Inputs/YesNoOption';
import ToggleSwitch from '../../../../uiToolkit/Inputs/ToggleSwitch';
import Dropdown from '../../../../uiToolkit/Inputs/Dropdown';
import {
  AiAssistantCommunicationOptions,
  AiAssistantResponseOptions,
} from '../../../../data/models/AI/AiAssisntantOptions';
import FormField from '../../GenerateAIAssistant/components/FormField';
import {generateAiAssistantText} from '../../GenerateAIAssistant/generateAiAssisntantText';
import './AiAssistantStep.css';

interface Props {
  addAiAssistant: boolean;
  setAddAiAssistant: (value: boolean) => void;
  assistantName: string;
  setAssistantName: (value: string) => void;
  assistantDescription: string;
  setAssistantDescription: (value: string) => void;
  assistantResponseStyle: string;
  setAssistantResponseStyle: (value: string) => void;
  assistantCommunicationTone: string;
  setAssistantCommunicationTone: (value: string) => void;
}

const AiAssistantStep = React.memo(
  ({
    addAiAssistant,
    setAddAiAssistant,
    assistantName,
    setAssistantName,
    assistantDescription,
    setAssistantDescription,
    assistantResponseStyle,
    setAssistantResponseStyle,
    assistantCommunicationTone,
    setAssistantCommunicationTone,
  }: Props) => {
    return (
      <div className="StepContainer">
        <h5 className="StepTitle">
          {generateAIVideosText.aiAssistantStep_pageTitle}
        </h5>
        <h5 className="SectionTitle mt-4">
          {generateAIVideosText.aiAssistantStep_addAiAssistantLabel}
        </h5>
        <p className="LessonGenVideoSubTitle">
          {generateAIVideosText.aiAssistantStep_addAiAssistantSubtitle}
        </p>
        <p>
          <YesNoOption
            onSelect={setAddAiAssistant}
            className="OptionsSection"
            value={addAiAssistant}
          />
        </p>
        {addAiAssistant && (
          <div className="AiAssistantStepContent">
            <div className="AiAssistantStepFormInnerHeader">
              <div className="AiAssistantStepTitleDesc AiAssistantStepTitleDescFull">
                <div className="AiAssitantTitleInput">
                  <span className="TitleStar">*</span>
                  <input
                    value={assistantName}
                    onChange={e => setAssistantName(e.target.value)}
                    className="TitleInput"
                    placeholder={generateAiAssistantText.titlePlaceholder}
                    maxLength={50}
                    disabled={!addAiAssistant}
                  />
                </div>
                <div className="TitleInputMaxCharacters">
                  <span>{assistantName.length}/50</span>
                </div>
                <textarea
                  name="AiAssistantStepDescriptionField"
                  value={assistantDescription}
                  onChange={e => setAssistantDescription(e.target.value)}
                  maxLength={300}
                  placeholder={generateAiAssistantText.descriptionPlaceholder}
                  disabled={!addAiAssistant}
                />
                <div className="TitleInputMaxCharacters">
                  <span>{assistantDescription.length}/300</span>
                </div>
              </div>
            </div>

            <FormField
              label={generateAiAssistantText.responseStyle}
              tooltip={generateAiAssistantText.responseStyleTooltip}>
              <ToggleSwitch
                options={AiAssistantResponseOptions}
                onChange={setAssistantResponseStyle}
                selectedKey={assistantResponseStyle}
                disabled={!addAiAssistant}
              />
            </FormField>

            <FormField label={generateAiAssistantText.communicationTone}>
              <Dropdown
                options={AiAssistantCommunicationOptions}
                selectedOption={assistantCommunicationTone}
                setSelectedOption={setAssistantCommunicationTone}
                placeholder="Select tone"
                fieldError={false}
                isMandatory
                disabled={!addAiAssistant}
              />
            </FormField>
          </div>
        )}
      </div>
    );
  },
);

export default AiAssistantStep;
